const sonidos = {
    namespaced: true,
    state: {
        
    },
    actions: {
        exito() {
            new Audio(require('./assets/sonidoExito.mp3')).play() 
        },
        error() {
            new Audio(require('./assets/sonidoError.mp3')).play() 
        }
    },
}

export default sonidos